 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		70: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		70: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendor~pages-Home-Home~pages-aboutUs-aboutUs-aboutUs~pages-aboutUs-becomeADistributor-becomeADistrib~65e2d3dc","1":"vendor~pages-aboutUs-aboutUs-aboutUs~pages-aboutUs-becomeADistributor-becomeADistributor~pages-about~88c792fa","2":"pages-itemAndBlog-customized-amulet-jewelPage~pages-itemAndBlog-customized-automotive-jewelPage~page~5009004d","3":"pages-Home-Home~pages-packagingBlog-blogDetail-blogPagetemplate-blogPage~pages-packagingBlog-packagingBlog","4":"vendor~pages-Home-Home~pages-aboutUs-corporateSocialResponsibility-corporateSocialResponsibility~db3~8ba70b51","5":"pages-Home-Home","6":"pages-aboutUs-aboutUs-aboutUs","7":"pages-aboutUs-becomeADistributor-becomeADistributor","8":"pages-aboutUs-corporateSocialResponsibility-corporateSocialResponsibility","9":"pages-aboutUs-qualityManagementSystem-qualityManagementSystem","10":"pages-aboutUs-sustainability-sustainability","11":"pages-aboutUs-thailandCraftman-thailandCraftman","12":"pages-boxMockups-boxMockups","13":"pages-brandingandLogoPrinting-brandingandLogoPrintings","14":"pages-contactUs-contactUs","15":"pages-customizedProjects-amulets-amulet","16":"pages-customizedProjects-automotive-automotive","17":"pages-customizedProjects-coin-coin","18":"pages-customizedProjects-cosmetics-cosmetics","19":"pages-customizedProjects-customizedProjects-customizedProjects","20":"pages-customizedProjects-fashion-fashion","21":"pages-customizedProjects-gold-gold","22":"pages-customizedProjects-jewel-jewel","23":"pages-customizedProjects-wineAndSpirits-wineAndSpirits","24":"pages-deliveryDestination-deliveryDestination","25":"pages-error-404","26":"pages-itemAndBlog-customized-amulet-jewelPage","27":"pages-itemAndBlog-customized-automotive-jewelPage","28":"pages-itemAndBlog-customized-coin-jewelPage","29":"pages-itemAndBlog-customized-cosmetic-jewelPage","30":"pages-itemAndBlog-customized-fashion-jewelPage","31":"pages-itemAndBlog-customized-gold-jewelPage","32":"pages-itemAndBlog-customized-wineAndSpirit-jewelPage","33":"pages-itemAndBlog-jewel-ecoFriendlyPackaging-jewelPage","34":"pages-itemAndBlog-jewel-ecommerceAssistant-jewelPage","35":"pages-itemAndBlog-jewel-jewelryBoxes-jewelPage","36":"pages-itemAndBlog-jewel-jewelryCases-jewelPage","37":"pages-itemAndBlog-jewel-jewelryDisplay-jewelPage","38":"pages-itemAndBlog-jewel-jewelryPouch-jewelPage","39":"pages-itemAndBlog-jewel-premiumPaperBags-jewelPage","40":"pages-itemAndBlog-jewel-ringBoxes-jewelPage","41":"pages-itemAndBlog-jewel-shoppingAid-jewelPage","42":"pages-itemAndBlog-jewel-watchDisplay-jewelPage","43":"pages-itemAndBlog-jewel-watchPackaing-jewelPage","44":"pages-ourMaterial-materialData-materialContainer","45":"pages-ourMaterial-ourMaterial","46":"pages-packaging-eCommerceAssistant-eCommerceAssistant","47":"pages-packaging-ecoFriendlyPackaging-ecoFriendlyPackaging","48":"pages-packaging-jewelryBoxes-jewelryBoxes","49":"pages-packaging-jewelryCases-jewelryCases","50":"pages-packaging-jewelryDisplay-jewelryDisplays","51":"pages-packaging-jewelryPouches-jewelryPouches","52":"pages-packaging-packaging-packaging","53":"pages-packaging-premiumPaperBags-premiumPaperBags","54":"pages-packaging-ringBoxes-ringBoxes","55":"pages-packaging-shoppiingAid-shoppingAids","56":"pages-packaging-shoppiingAid-shoppingAidsJewelryTray-shoppingAidItem","57":"pages-packaging-shoppiingAid-shoppingAidsMirror-shoppingAidItem","58":"pages-packaging-shoppiingAid-shoppingAidsTissueBox-shoppingAidItem","59":"pages-packaging-smartPackaging-smartPackaging","60":"pages-packaging-watchDisplay-watchDisplays","61":"pages-packaging-watchPackaging-watchPackaging","62":"pages-packagingBlog-blogDetail-blogPagetemplate-blogPage","63":"pages-packagingBlog-packagingBlog","64":"pages-perfumePackaging-perfumePackaging","65":"pages-privacy","66":"pages-professionalConsultation-professional-Consultation","67":"pages-sitemap-Sitemap","68":"pages-termOfUser","69":"pages-workWithUs-workWithUs"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"62":1,"63":1,"64":1,"65":1,"66":1,"67":1,"68":1,"69":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendor~pages-Home-Home~pages-aboutUs-aboutUs-aboutUs~pages-aboutUs-becomeADistributor-becomeADistrib~65e2d3dc","1":"vendor~pages-aboutUs-aboutUs-aboutUs~pages-aboutUs-becomeADistributor-becomeADistributor~pages-about~88c792fa","2":"pages-itemAndBlog-customized-amulet-jewelPage~pages-itemAndBlog-customized-automotive-jewelPage~page~5009004d","3":"pages-Home-Home~pages-packagingBlog-blogDetail-blogPagetemplate-blogPage~pages-packagingBlog-packagingBlog","4":"vendor~pages-Home-Home~pages-aboutUs-corporateSocialResponsibility-corporateSocialResponsibility~db3~8ba70b51","5":"pages-Home-Home","6":"pages-aboutUs-aboutUs-aboutUs","7":"pages-aboutUs-becomeADistributor-becomeADistributor","8":"pages-aboutUs-corporateSocialResponsibility-corporateSocialResponsibility","9":"pages-aboutUs-qualityManagementSystem-qualityManagementSystem","10":"pages-aboutUs-sustainability-sustainability","11":"pages-aboutUs-thailandCraftman-thailandCraftman","12":"pages-boxMockups-boxMockups","13":"pages-brandingandLogoPrinting-brandingandLogoPrintings","14":"pages-contactUs-contactUs","15":"pages-customizedProjects-amulets-amulet","16":"pages-customizedProjects-automotive-automotive","17":"pages-customizedProjects-coin-coin","18":"pages-customizedProjects-cosmetics-cosmetics","19":"pages-customizedProjects-customizedProjects-customizedProjects","20":"pages-customizedProjects-fashion-fashion","21":"pages-customizedProjects-gold-gold","22":"pages-customizedProjects-jewel-jewel","23":"pages-customizedProjects-wineAndSpirits-wineAndSpirits","24":"pages-deliveryDestination-deliveryDestination","25":"pages-error-404","26":"pages-itemAndBlog-customized-amulet-jewelPage","27":"pages-itemAndBlog-customized-automotive-jewelPage","28":"pages-itemAndBlog-customized-coin-jewelPage","29":"pages-itemAndBlog-customized-cosmetic-jewelPage","30":"pages-itemAndBlog-customized-fashion-jewelPage","31":"pages-itemAndBlog-customized-gold-jewelPage","32":"pages-itemAndBlog-customized-wineAndSpirit-jewelPage","33":"pages-itemAndBlog-jewel-ecoFriendlyPackaging-jewelPage","34":"pages-itemAndBlog-jewel-ecommerceAssistant-jewelPage","35":"pages-itemAndBlog-jewel-jewelryBoxes-jewelPage","36":"pages-itemAndBlog-jewel-jewelryCases-jewelPage","37":"pages-itemAndBlog-jewel-jewelryDisplay-jewelPage","38":"pages-itemAndBlog-jewel-jewelryPouch-jewelPage","39":"pages-itemAndBlog-jewel-premiumPaperBags-jewelPage","40":"pages-itemAndBlog-jewel-ringBoxes-jewelPage","41":"pages-itemAndBlog-jewel-shoppingAid-jewelPage","42":"pages-itemAndBlog-jewel-watchDisplay-jewelPage","43":"pages-itemAndBlog-jewel-watchPackaing-jewelPage","44":"pages-ourMaterial-materialData-materialContainer","45":"pages-ourMaterial-ourMaterial","46":"pages-packaging-eCommerceAssistant-eCommerceAssistant","47":"pages-packaging-ecoFriendlyPackaging-ecoFriendlyPackaging","48":"pages-packaging-jewelryBoxes-jewelryBoxes","49":"pages-packaging-jewelryCases-jewelryCases","50":"pages-packaging-jewelryDisplay-jewelryDisplays","51":"pages-packaging-jewelryPouches-jewelryPouches","52":"pages-packaging-packaging-packaging","53":"pages-packaging-premiumPaperBags-premiumPaperBags","54":"pages-packaging-ringBoxes-ringBoxes","55":"pages-packaging-shoppiingAid-shoppingAids","56":"pages-packaging-shoppiingAid-shoppingAidsJewelryTray-shoppingAidItem","57":"pages-packaging-shoppiingAid-shoppingAidsMirror-shoppingAidItem","58":"pages-packaging-shoppiingAid-shoppingAidsTissueBox-shoppingAidItem","59":"pages-packaging-smartPackaging-smartPackaging","60":"pages-packaging-watchDisplay-watchDisplays","61":"pages-packaging-watchPackaging-watchPackaging","62":"pages-packagingBlog-blogDetail-blogPagetemplate-blogPage","63":"pages-packagingBlog-packagingBlog","64":"pages-perfumePackaging-perfumePackaging","65":"pages-privacy","66":"pages-professionalConsultation-professional-Consultation","67":"pages-sitemap-Sitemap","68":"pages-termOfUser","69":"pages-workWithUs-workWithUs"}[chunkId]||chunkId) + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push(["./src/index.ssr.js",75,71,77,73,79,72,76,78,81,74,80]);
 	// run deferred modules when ready
 	return checkDeferredModules();
